import PageLayout from '@/components/shared/PageLayout';
import ProgressionModelContent from "@/components/progression-model-content";

export default function ProgressionModelPage() {
  return (
    <PageLayout
      title="Progression Model"
      subtitle="Three-phase reference for gates, transitions, and drill progression"
      compactContent
    >
      <ProgressionModelContent />
    </PageLayout>
  );
}
